import React from 'react';
import PropTypes from 'prop-types';

import * as templates from './templates';

const defaultFormat = 'base';

const StaticAddress = ({ format, address = {} }) => {
  const Template = templates[(format || defaultFormat).toLowerCase()] || templates[defaultFormat];

  return <Template {...address} />;
};

StaticAddress.propTypes = {
  format: PropTypes.string,
  address: PropTypes.shape({
    street: PropTypes.node,
    number: PropTypes.node,
    aptNumber: PropTypes.node,
    address1: PropTypes.node,
    address2: PropTypes.node,
    city: PropTypes.node,
    zipcode: PropTypes.node,
    regionName: PropTypes.node,
    regionCode: PropTypes.node,
    countryName: PropTypes.node,
    countryCode: PropTypes.node,
  }).isRequired,
};

StaticAddress.defaultProps = {
  format: defaultFormat,
};

export default StaticAddress;
